"use strict";
// Copyright © 2021 Move Closer
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.moduleDriverFormComponentRegistry = void 0;
const _contracts_1 = require("./_contracts");
const form_1 = require("./About/form");
const form_2 = require("./ArticlesList/form");
const form_3 = require("./Blockquote/form");
const form_4 = require("./Boxes/form");
const form_5 = require("./Contact/form");
const form_6 = require("./EditorialOffice/form");
const form_7 = require("./Embed/form");
const form_8 = require("./Experts/form");
const form_9 = require("./Gallery/form");
const form_10 = require("./HTML/form");
const form_11 = require("./Heading/form");
const form_12 = require("./HeadingCountdown/form");
const form_13 = require("./Hero/form");
const form_14 = require("./Image/form");
const form_15 = require("./List/form");
const form_16 = require("./LiveFeed/form");
const form_17 = require("./Logos/form");
const form_18 = require("./NewsBar/form");
const form_19 = require("./Newsletter/form");
const form_20 = require("./Pagination/form");
const form_21 = require("./Paragraph/form");
const form_22 = require("./Partners/form");
const form_23 = require("./Quotes/form");
const form_24 = require("./ReadMore/form");
const form_25 = require("./RelatedArticles/form");
const form_26 = require("./RequestAccess/form");
const form_27 = require("./StickyBar/form");
const form_28 = require("./TeaserBox/form");
const form_29 = require("./Testimonials/form");
const form_30 = require("./Tile/form");
const AuthorCard_form_1 = __importDefault(require("./AuthorCard/AuthorCard.form"));
const RandomImage_form_1 = require("./RandomImage/RandomImage.form");
/**
 * Registry that binds the `ModuleDriver` with the corresponding module's form component.
 *
 * @author Stanisław Gregor <stanislaw.gregor@movecloser.pl>
 */
exports.moduleDriverFormComponentRegistry = {
    [_contracts_1.ModuleDriver.About]: form_1.AboutModuleForm,
    [_contracts_1.ModuleDriver.ArticlesList]: form_2.ArticlesListModuleForm,
    [_contracts_1.ModuleDriver.AuthorCard]: AuthorCard_form_1.default,
    [_contracts_1.ModuleDriver.Blockquote]: form_3.BlockquoteModuleForm,
    [_contracts_1.ModuleDriver.Boxes]: form_4.BoxesModuleForm,
    [_contracts_1.ModuleDriver.Contact]: form_5.ContactModuleForm,
    [_contracts_1.ModuleDriver.EditorialOffice]: form_6.EditorialOfficeModuleForm,
    [_contracts_1.ModuleDriver.Embed]: form_7.EmbedModuleForm,
    [_contracts_1.ModuleDriver.Experts]: form_8.ExpertsModuleForm,
    [_contracts_1.ModuleDriver.Gallery]: form_9.GalleryModuleForm,
    [_contracts_1.ModuleDriver.HTML]: form_10.HTMLModuleForm,
    [_contracts_1.ModuleDriver.Heading]: form_11.HeadingModuleForm,
    [_contracts_1.ModuleDriver.HeadingCountdown]: form_12.HeadingCountdownModuleForm,
    [_contracts_1.ModuleDriver.Hero]: form_13.HeroModuleForm,
    [_contracts_1.ModuleDriver.Image]: form_14.ImageModuleForm,
    [_contracts_1.ModuleDriver.List]: form_15.ListModuleForm,
    [_contracts_1.ModuleDriver.LiveFeed]: form_16.LiveFeedModuleForm,
    [_contracts_1.ModuleDriver.Logos]: form_17.LogosModuleForm,
    [_contracts_1.ModuleDriver.NewsBar]: form_18.NewsBarModuleForm,
    [_contracts_1.ModuleDriver.Newsletter]: form_19.NewsletterModuleForm,
    [_contracts_1.ModuleDriver.Pagination]: form_20.PaginationModuleForm,
    [_contracts_1.ModuleDriver.Paragraph]: form_21.ParagraphModuleForm,
    [_contracts_1.ModuleDriver.Partners]: form_22.PartnersModuleForm,
    [_contracts_1.ModuleDriver.Quotes]: form_23.QuotesModuleForm,
    [_contracts_1.ModuleDriver.RandomImage]: RandomImage_form_1.RandomImageModuleForm,
    [_contracts_1.ModuleDriver.ReadMore]: form_24.ReadMoreModuleForm,
    [_contracts_1.ModuleDriver.RelatedArticles]: form_25.RelatedArticlesModuleForm,
    [_contracts_1.ModuleDriver.RequestAccess]: form_26.RequestAccessModuleForm,
    [_contracts_1.ModuleDriver.StickyBar]: form_27.StickyBarModuleForm,
    [_contracts_1.ModuleDriver.TeaserBox]: form_28.TeaserBoxModuleForm,
    [_contracts_1.ModuleDriver.Tile]: form_30.TileModuleForm,
    [_contracts_1.ModuleDriver.Testimonials]: form_29.TestimonialsModuleForm
};
//# sourceMappingURL=driver-component.registry.form.js.map